import { signInWithEmailAndPassword } from "firebase/auth";
import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

import { auth } from "../firebase.config";

/**
 * First factor: email + password against Firebase. The facial-recognition
 * second factor runs *after* this succeeds, in SecondFactorGate (which wraps
 * the app shell), so it can't be skipped by the post-login redirect.
 */
export function SignIn() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/app", { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Sign-in failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="portal-page">
      <div className="portal-form">
        <div className="portal-brand">
          <div className="portal-mark" aria-hidden>◆</div>
          <h1>Campaign Intelligence</h1>
          <p className="portal-sub">Sign in to continue</p>
        </div>

        <form onSubmit={onSubmit} className="portal-fields">
          <input
            type="email"
            autoComplete="username"
            required
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            autoComplete="current-password"
            required
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button type="submit" disabled={busy}>
            {busy ? "Verifying…" : "Sign in"}
          </button>
          {error && (
            <p role="alert" style={{ color: "#b14444", fontSize: 13, margin: 0 }}>
              {error}
            </p>
          )}
        </form>
      </div>
    </div>
  );
}
